import { HttpService } from "services";
import { UserRole } from "types/entities";
import { CreateTitleCompanyFunction } from "types/functions/createTitleCompany";
import { AuthorizationLevel } from "types/http";

/**
 * Create user as a administrator
 *
 * @throws {UserServiceException}
 */
export const createTitleCompany: CreateTitleCompanyFunction = async (
  ...args: Parameters<CreateTitleCompanyFunction>
) => {
  try {
    const { title_company, company_address, email, phone_no, territory } =
      args[0];
    await HttpService.fetch(
      "/title-company",
      {
        requestConfig: {
          method: "POST",
          data: {
            email,
            company_address: company_address,
            title_company: title_company,
            territory,
            phone_no,
          },
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return true;
  } catch (error) {
    throw error;
  }
};
